import createIcon from '../../createIcon';

/**
 * @component @name FlightClass
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTYuNSAzLjVIMTQuNUMxMy40IDMuNSAxMi41IDQuNCAxMi41IDUuNVYxMC41QzEyLjUgMTEuNiAxMy40IDEyLjUgMTQuNSAxMi41SDE2LjVDMTcuNiAxMi41IDE4LjUgMTEuNiAxOC41IDEwLjVWNS41QzE4LjUgNC40IDE3LjYgMy41IDE2LjUgMy41Wk0xMCAxNS41SDE4LjVWMTcuNUg5Ljk5QzkuMTEgMTcuNSA4LjMzIDE2LjkyIDguMDcgMTYuMDdMNS41IDcuNVYzLjVINy41VjcuNUwxMCAxNS41Wk04LjUgMTguNUgxOC41VjIwLjVIOC41VjE4LjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FlightClass = createIcon('FlightClass', [
  [
    'path',
    {
      d: 'M16.5 3.5H14.5C13.4 3.5 12.5 4.4 12.5 5.5V10.5C12.5 11.6 13.4 12.5 14.5 12.5H16.5C17.6 12.5 18.5 11.6 18.5 10.5V5.5C18.5 4.4 17.6 3.5 16.5 3.5ZM10 15.5H18.5V17.5H9.99C9.11 17.5 8.33 16.92 8.07 16.07L5.5 7.5V3.5H7.5V7.5L10 15.5ZM8.5 18.5H18.5V20.5H8.5V18.5Z',
      key: 'mzrn08',
    },
  ],
]);

export default FlightClass;
